import React from "react";
import { Link } from "react-router-dom";

import saas from '../assets/images/saas/1.png'

import { TbBolt, BsPentagon, FiArrowRight} from '../assets/icons/icons'

export default function AnalyticsTwo(){
    return(
            <div className="row align-items-center">
                <div className="col-md-7">
                    <div className="me-lg-5">
                        <div className="section-title">
                            <h6 className="text-primary">Analytics</h6>
                            <h4 className="title mb-4">Analyze your data with <br/> our analysis tools.</h4>
                            <p className="text-muted para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mt-4 pt-2">
                                <div className="card features feature-primary bg-transparent border-0">
                                    <div className="icon text-center rounded-md">
                                        <h3 className="mb-0"><TbBolt/></h3>
                                    </div>
                                    <div className="card-body p-0 mt-4">
                                        <h5>Unlimited Power</h5>
                                        <p className="text-muted mb-0">Composed in a pseudo-Latin language which more or less corresponds.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 mt-4 pt-2">
                                <div className="card features feature-primary bg-transparent border-0">
                                    <div className="icon text-center rounded-md">
                                        <h3 className="mb-0"><BsPentagon /></h3>
                                    </div>
                                    <div className="card-body p-0 mt-4">
                                        <h5>Professional Design</h5>
                                        <p className="text-muted mb-0">Composed in a pseudo-Latin language which more or less corresponds.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mt-4 pt-2">
                            <Link to="#" className="btn btn-soft-primary">Try for free <FiArrowRight className="fea icon-sm"/></Link>
                        </div>
                    </div>
                </div>

                <div className="col-md-5 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <img src={saas} className="img-fluid" alt=""/>
                </div>
            </div>
    )
}